import { Bindi } from "@/components/motifs";

const WORDS = [
  "Madhubani",
  "Mithila",
  "Peacock",
  "Lotus",
  "Fish",
  "Sun",
  "Geometry",
  "Devotion",
  "Line & Colour",
  "Bhopal — Patna",
  "Living Tradition",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="px-8 font-serif text-xl italic tracking-wide text-muted-foreground sm:text-2xl">{w}</span>
        <Bindi size={7} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="overflow-hidden border-y border-border py-5" aria-hidden="true" data-testid="editorial-marquee">
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
